module.exports = __webpack_public_path__ + "img/zi.5369f29e.png";